import { useUserOrgData } from '#pplx/frontend/apps/ask/organization/hooks/useUserOrgData.js';
import { useBooleanFlagValue } from '#pplx/frontend/experimentation/hooks.js';
import { useMemo } from 'react';
/**
 * Determines if the Max tier upsell feature is enabled for the current user.
 *
 * For enterprise users, Max upsell is always enabled.
 * For non-enterprise users, it's controlled by the 'max-upsell' feature flag.
 */
export function useMaxTierEnabled() {
    const { isEnterprise } = useUserOrgData({ reason: 'max-tier' });
    const { variation: isMaxUpsellEnabled, loading } = useBooleanFlagValue({
        flag: 'max-upsell',
        defaultValue: false,
    });
    return useMemo(() => ({
        isMaxUpsellEnabled: isEnterprise ? true : isMaxUpsellEnabled,
        loading,
    }), [isMaxUpsellEnabled, loading, isEnterprise]);
}
//# sourceMappingURL=useMaxTierEnabled.js.map